













































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateBoccoChannelFormValue } from '../form/CreateBoccoChannelForm.vue'


@Component
export default class ConfirmCreateBoccoChannelModal extends Vue {
    @Prop({required: true})
    value!: CreateBoccoChannelFormValue

    @Prop()
    editMode?: boolean

    previewUrl: string | null = null

    isClick = false

    get action() {
        if (this.editMode) {
            return "編集"
        } else {
            return "作成"
        }
    }


    mounted() {
        if (this.value.file) {
            this.previewUrl = window.URL.createObjectURL(this.value.file)
        }
    }

    click() {
        if (this.isClick) {
            return
        }
        this.isClick = true

        this.$emit('approve')
    }

}
